import React, { forwardRef, ReactElement, ReactNode, Ref } from 'react'

import { Size } from '../../types/size'
import * as Styled from './styles'

interface ModalBodyProps {
  children?: ReactNode
  className?: string
  size?: Size
}

export const ModalBody = forwardRef(
  ({ children, className, size }: ModalBodyProps, ref: Ref<HTMLDivElement>): ReactElement => (
    <Styled.ModalBodyWrapper ref={ref} className={className} size={size}>
      {children}
    </Styled.ModalBodyWrapper>
  ),
)
